import React from "react";

import TableCell from "@material-ui/core/TableCell";

import MaterialInput from "@material-ui/core/Input";
import NativeSelect from "@material-ui/core/NativeSelect";

class Input extends React.Component {
  onEditChange(key, value) {
    const onEditChange = this.props.onEditChange || null;
    if (onEditChange) {
      onEditChange(key, value);
    }
  }

  render() {
    const { row, column } = this.props;
    const { values } = column;

    let value = row[column.key] ?? false;

    if (value === false) {
      value = "";
      if (column.format) {
        if (typeof column.format === "function") {
          value = column.format(value, row);
        }
      }
    }

    if (values) {
      return (
        <TableCell scope="row">
          <NativeSelect
            defaultValue={value}
            fullWidth
            margin="dense"
            onChange={(e) => this.onEditChange(column.key, e.target.value)}
            native={true}
          >
            {values.map((item) => (
              <option value={item.id}>{item.name}</option>
            ))}
          </NativeSelect>
        </TableCell>
      );
    }

    return (
      <TableCell scope="row">
        <MaterialInput
          defaultValue={value}
          fullWidth
          margin="dense"
          onChange={(e) => this.onEditChange(column.key, e.target.value)}
        />
      </TableCell>
    );
  }
}

export default Input;
